"use client";

import React, { Suspense, useState } from "react";
import HeaderBanner from "@packages/shared-components/common-utilities/header-banner/header-banner";
import HeaderBannerSkeleton from "@packages/shared-components/skeleton/institution-profile/header-banner-skeleton";
import InterestedSkeleton from "@packages/shared-components/skeleton/institution-profile/interested-skeleton";
import { isPGS, isWhatuni } from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import SchemaTagLayoutComponent from "@packages/shared-components/common-utilities/schematag-layout/SchemaTagLayoutComponent";
import { getHeaderCtaCount } from "@packages/lib/utlils/enquiry-utils";
import FavFunctionalityWrapper from "@packages/shared-components/common-utilities/user-favourite/FavFunctionalityWrapper";
import ReviewFilters from "@packages/shared-components/university-course-reviews/review-filters";
import StudentRating from "@packages/shared-components/common-utilities/student-rating/student-rating";
import WuscaBadge from "@packages/shared-components/common-utilities/wusca-badge/wusca-badge";
import UserReviewList from "@packages/shared-components/university-course-reviews/user-review-list";
import TabViewComponents from "../common-utilities/tab-view/tabviewcomponents";
import PageViewLogging from "@packages/lib/utlils/pageviewlogging";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { GAConstants } from "../services/constants";
// import AiSummarizedReviewContents from "@packages/shared-components/university-course-reviews/ai-summarized-review-contents";
// import PageViewLogging from "@packages/lib/utlils/pageviewlogging";

const InterestedContent = React.lazy(
  () =>
    import("@packages/shared-components/university-course-reviews/InterestedReview"),
);

interface InYearInstitutionProfileProps {
  slug: string;
  uniId: number;
  universityReviewDetail: any;
  userReviewDetails: any;
  reviewSubjects: any;
  routes?: any;
  gaPageName?: any;
  isPostgraduate?: any;
  queryParams?: any;
}

const UniversityCourseReviews = ({
  routes,
  uniId,
  universityReviewDetail,
  userReviewDetails,
  reviewSubjects,
  gaPageName,
  isPostgraduate,
  queryParams,
}: InYearInstitutionProfileProps) => {
  let [filterVisible, setFilterVisisble] = useState(false);
  const isAdvertiser = !!universityReviewDetail?.enquiryDetails?.subOrderItemId;
  const defaultFragmentId =
    universityReviewDetail?.sectionsList?.[0]?.sectionUrl;
  const searchParams = useSearchParams();

  const getCpeParentSubjects = () => {
    const subjectsParam = searchParams.get("subjects");
    const subjectCodes = subjectsParam?.split("+") || [];
    if (!Array.isArray(reviewSubjects?.subjects) || !subjectCodes.length)
      return "NA";
    const matches = subjectCodes
      .map((code: string) => {
        const trimmedCode = code.trim();
        const subject = reviewSubjects.subjects.find(
          (s: any) => s.catCode === trimmedCode,
        );
        return subject ? subject.description : null;
      })
      .filter(Boolean);
    return matches.length ? matches.join(", ") : "NA";
  };

  const commonGAAttrs = {
    page_name: gaPageName || "morereviews.jsp",
    institution_name: universityReviewDetail?.uniInfo?.institutionName,
    provider_type: isAdvertiser ? "advertiser" : "non_advertiser",
    institution_id: `${universityReviewDetail?.uniInfo?.institutionId}`,
    //clearing: "in_year",
    study_level: searchParams.get("studyLevel") || "undergraduate",
    destination_region_city:
      universityReviewDetail?.cityDetails?.destinationCountry,
    subject_area: getCpeParentSubjects(),
    page_grouping: GAConstants.pageGrouping.reviews_institution_page,
  };

  const commonGAAttrsOld = {
    page_name: gaPageName || "morereviews.jsp",
    college_name: universityReviewDetail?.uniInfo?.institutionName,
    provider_type: isAdvertiser ? "advertiser" : "non_advertiser",
    college_id: `${universityReviewDetail?.uniInfo?.institutionId}`,
    clearing: "in_year",
    study_level: searchParams.get("studyLevel") || "undergraduate",
    destination_country:
      universityReviewDetail?.cityDetails?.destinationCountry,
    cpe_parent_subject: getCpeParentSubjects(),
  };

  const CSCommonData = (): ClickstreamInterface => {
    return {
      pageName: gaPageName || "morereviews.jsp",
      orderItemId: universityReviewDetail?.enquiryDetails?.orderItemId,
      subOrderItemId: universityReviewDetail?.enquiryDetails?.subOrderItemId,
      isAdvertiser: isAdvertiser ? "Y" : "N",
      idpcInstitutionId: universityReviewDetail?.uniInfo?.institutionId,
      studyLevel: isPGS() || isPostgraduate ? "Postgraduate" : "Degree",
      studyLevelId: isPGS() || isPostgraduate ? 18 : 17,
      networkId: isPGS() || isPostgraduate ? 3 : 2,
    };
  };

  const btncount = getHeaderCtaCount({
    websiteFlag: universityReviewDetail?.enquiryDetails?.websiteFlag,
    callNowFlag: universityReviewDetail?.enquiryDetails?.callNowFlag,
    opendayFlag: universityReviewDetail?.enquiryDetails?.opendayFlag,
    prospectusFlag: universityReviewDetail?.enquiryDetails?.prospectusFlag,
    emailFlag:
      universityReviewDetail?.enquiryDetails?.emailFlag === "Y" ||
      !universityReviewDetail?.enquiryDetails?.subOrderItemId
        ? "Y"
        : "N",
    applyNowFlag: universityReviewDetail?.enquiryDetails?.applyNowFlag,
    recommendedUni:
      !universityReviewDetail?.enquiryDetails?.subOrderItemId &&
      !isAdvertiser &&
      !!universityReviewDetail?.recommendPod
        ? "Y"
        : "N",
  });

  return (
    <div>
      <PageViewLogging
        pageNameLocal={gaPageName}
        clearing={"in_year"}
        gaData={commonGAAttrs}
        gaoldData={commonGAAttrsOld}
        csData={CSCommonData()}
      />

      {/* {isWhatuni() && (
        <Suspense fallback={<InterestedSkeleton />}>
          <InterestedContent routesData={routes?.profileTabDetails} />
        </Suspense>
      )} */}
      {!!universityReviewDetail?.reviewRating?.reviewCount && (
        <SchemaTagLayoutComponent
          schemaType="CollegeOrUniversity"
          schemaData={
            universityReviewDetail?.reviewRating?.overallRatingExact ||
            universityReviewDetail?.reviewRating?.overallRating
              ? {
                  name:
                    universityReviewDetail?.uniInfo?.institutionName ??
                    "University Name",
                  aggregateRating: {
                    "@type": "AggregateRating",
                    ratingValue:
                      universityReviewDetail?.reviewRating
                        ?.overallRatingExact ??
                      universityReviewDetail?.reviewRating?.overallRating,
                    reviewCount:
                      universityReviewDetail?.reviewRating?.reviewCount,
                  },
                }
              : undefined
          }
        />
      )}
      <FavFunctionalityWrapper
        commonGAAttrs={commonGAAttrs}
        cSCommonData={CSCommonData()}
      >
        <Suspense fallback={<HeaderBannerSkeleton />}>
          <HeaderBanner
            h1TitleFormat={"[COLLEGE NAME] Reviews"}
            uniInfo={{
              ...universityReviewDetail?.uniInfo,
              overallRatingExact: universityReviewDetail?.overallRatingExact,
              wuscaRanking: universityReviewDetail?.overallRanking,
            }}
            enquiryDetails={universityReviewDetail?.enquiryDetails ?? undefined}
            isClearing={false}
            isVirtualTourAvailable={
              universityReviewDetail?.uniInfo?.veppleDetails?.toLowerCase() ===
              "y"
            }
            gallery={universityReviewDetail?.galleryDetails}
            hasRecommendedUni={
              !isAdvertiser && !!universityReviewDetail?.recommendPod
            }
            commonGAAttrs={commonGAAttrs}
            btncount={btncount}
            isPostgraduate={isPostgraduate}
            csCommonData={CSCommonData()}
            defaultFragmentId={defaultFragmentId}
            commonOldGAAttrs={commonGAAttrsOld}
          />
        </Suspense>
        <TabViewComponents
          tabSectionList={universityReviewDetail?.tabSectionList}
          sectionId="university-course-reviews"
          commonGAAttrs={commonGAAttrs}
        />
        {filterVisible && (
          <div
            className={
              "w-full h-full fixed top-0 left-0 z-[9] opacity-80 bg-[#333f48] lg:hidden"
            }
            onClick={() => setFilterVisisble((prev: boolean) => !prev)}
          ></div>
        )}
        <section className="bg-white">
          <div className="max-w-container mx-auto py-[24px] px-[16px] pb-[32px] lg:py-[40px] lg:px-[20px] xl:px-0">
            <div className="flex flex-col lg:flex-row gap-[32px] lg:gap-[20px] ">
              {/* Side content and filters */}
              <ReviewFilters
                totalReviewCount={universityReviewDetail?.uniInfo?.reviewCount}
                starRatingPercentage={
                  universityReviewDetail?.starRatingPercentage || []
                }
                filterVisible={filterVisible}
                setFilterVisisble={setFilterVisisble}
                reviewSubjects={reviewSubjects}
                commonGAAttrs={commonGAAttrs}
                commonGAAttrsOld={commonGAAttrsOld}
              />
              {/* Side content and filters */}

              <div className="w-full flex flex-col flex-1 gap-[16px] md:gap-[24px] lg:gap-[40px] lg:w-[calc(100%_-_309px)]">
                <div className="flex flex-col gap-[8px]">
                  <div className="h3 text-grey300 text-[24px] md:text-[28px] font-bold font-farro inline">
                    <svg
                      className="inline-block  mr-[7px]"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 7.0625C3 5.26757 4.45507 3.8125 6.25 3.8125H17.625C19.4199 3.8125 20.875 5.26757 20.875 7.0625V13.5625C20.875 15.3574 19.4199 16.8125 17.625 16.8125H14.375L9.5 21.6875V16.8125H6.25C4.45507 16.8125 3 15.3574 3 13.5625V7.0625Z"
                        fill="#333333"
                      />
                      <path
                        d="M24.125 10.3125V16.0625C24.125 18.2716 22.3341 20.0625 20.125 20.0625H15.7212L12.8503 22.9334C13.305 23.1754 13.824 23.3125 14.375 23.3125H17.625L22.5 28.1875V23.3125H25.75C27.5449 23.3125 29 21.8574 29 20.0625V13.5625C29 11.7676 27.5449 10.3125 25.75 10.3125H24.125Z"
                        fill="#333333"
                      />
                    </svg>
                    Is {universityReviewDetail?.uniInfo?.institutionName} a good
                    place to study?
                  </div>
                  <p className="text-grey300 text-base font-normal font-inter">
                    Read honest reviews from real students at this uni
                  </p>
                </div>

                {/* <AiSummarizedReviewContents /> */}

                <div className="flex flex-col gap-[16px]">
                  <div className="border border-grey-200 bg-grey-50 rounded-[8px]">
                    {universityReviewDetail?.wuscaBadges?.length !== 0 && (
                      <WuscaBadge
                        show={true}
                        items={universityReviewDetail?.wuscaBadges}
                      />
                    )}
                    {universityReviewDetail?.studentOverallCategoryRating
                      ?.length > 0 && (
                      <StudentRating
                        data={
                          universityReviewDetail?.studentOverallCategoryRating
                        }
                        commonGAAttrs={commonGAAttrs}
                      />
                    )}
                  </div>
                </div>

                <UserReviewList
                  userReviewDetails={userReviewDetails}
                  uniInfo={universityReviewDetail?.uniInfo}
                  setFilterVisisble={setFilterVisisble}
                  commonGAAttrs={commonGAAttrs}
                  commonGAAttrsOld={commonGAAttrsOld}
                />
              </div>
            </div>
          </div>
        </section>
      </FavFunctionalityWrapper>
    </div>
  );
};

export default UniversityCourseReviews;
